// This composable is responsible for handling types/flags of products
import { camelCase, toLower } from 'lodash';
import { useFeature } from '@/composables/use-feature';
// utilities
import originSourceTypes from '@enums/origin-source-types';
import productModellingTypes from '@enums/product-modelling-types';

export function useProductIndicators() {
  const { hasProductsExistingFromNewInTemplateEnabled } = useFeature();

  const getProductType = productData => {
    const {
      toolGenerated,
      userGenerated,
      newProduct,
      semiNewProduct,
      existingProduct,
      romProduct,
    } = productModellingTypes;
    if (productData.isToolGenerated === true) return toolGenerated;
    if (productData.isToolGenerated === false) return userGenerated;
    if (productData.fromRestOfMarket) return romProduct;
    const isSemiNewProduct =
      !productData.isNewProduct && productData.originSource === originSourceTypes.newInTemplate;
    if (hasProductsExistingFromNewInTemplateEnabled.value && isSemiNewProduct)
      return semiNewProduct;
    return productData.isNewProduct ? newProduct : existingProduct;
  };

  // We need tkey as a param since we can have different localizationkey
  const getProductTypeDisplayString = (productType, tkey) => {
    const translationKey = `attributes.${productType}`;
    const translationValue = tkey(translationKey);
    if (translationValue.length > 5) return translationValue.slice(0, 5);
    return translationValue;
  };

  const getProductModellingTag = (product, isUnclusteredCanvas = null) => {
    const { modellingType, assortment, fromRestOfMarket, isNewProduct, originSource } = product;
    if (
      !assortment || // We don't want to show flags for discontinued products
      // don't show tag if modelledInCluster and user is on unclustered canvas
      (modellingType === productModellingTypes.modellingTypes.modelledInCluster &&
        isUnclusteredCanvas === true) ||
      modellingType === productModellingTypes.modellingTypes.established
    ) {
      // Scenario products will be marked as modelledInCluster if it is modelled in one, some
      // or all clusters so that it can be shown in product modelling dashboard, however we
      // don't want to show the modelledInCluster tag on the assortment page in this case
      return '';
    }
    // ROM products are new products but we need to mark them with a different tag
    if (fromRestOfMarket) return toLower(productModellingTypes.modellingTypes.rom);
    const isSemiNewProduct = !isNewProduct && originSource === originSourceTypes.newInTemplate;
    if (hasProductsExistingFromNewInTemplateEnabled.value && isSemiNewProduct)
      return camelCase(productModellingTypes.modellingTypes.semiNew);
    return modellingType || '';
  };

  return { getProductType, getProductModellingTag, getProductTypeDisplayString };
}
